import React from "react";

const GetStarted = React.lazy(() => import("./subcomponent/GetStarted"));

const components = {
  GetStarted,
};

function Component(props) {
  const DynamicComponent = components[props.component];
  if (!components[props.component]) {
    return <p>Component is not defined: {props.component}</p>;
  }

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <DynamicComponent {...props} />
    </React.Suspense>
  );
}

export { Component };
